import { language as lan_submitexpress } from "./submit-express";

const language = {
    ...lan_submitexpress,
    RETURN_DETAIL_EMPTY: "退货订单不存在！",
    RETURN_DETAIL_RETURN: "退货详情",
    RETURN_DETAIL_RETURN_NO: "退货编号",
    RETURN_DETAIL_ORDER_NO: "订单编号",
    RETURN_DETAIL_RETURN_ITEM: "退货商品",
    RETURN_DETAIL_QUANTITY: "数量",
    RETURN_DETAIL_QTY: "退货数量",
    RETURN_DETAIL_REASON: "退货原因",
    RETURN_DETAIL_DESCRIPTION: "描述",
    RETURN_DETAIL_PHOTOS: "照片",
    RETURN_DETAIL_STATUS: "状态",
    RETURN_DETAIL_CANCEL_RETURN: "取消退货",
    RETURN_DETAIL_EXPRESS: "填写快递信息",
    RETURN_DETAIL_CLOSE: "关闭"
}

export { language }
